<template>
    <div class="animated fadeIn container-fluid">

        <!-- 阿龜資料讀取畫面 -->
        <div v-if="loading">
            <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
        </div>
        <div v-else-if="device">

            <b-row>
                <b-col md="4" v-if="is_create == false">
                    <div class="proj-toolbox-area">
                        前往愛管侍：
                        <img class="btn-indeedee"
                            :src="$config.getAssetsURL('img/brand/sidebar_icon.png')"
                            @click="$config.goTo_Iguanshi('accesspoint', { deviceID: device.hashid })"
                            :alt="'go to IGuanShi: ' + device.hashid"
                        />
                    </div>
                </b-col>
                <b-col md="2" v-else></b-col>
                <b-col md="8">
                    <div class="proj-toolbox-area">

                        <h4>編輯 AccessPoint 資訊</h4>
                        <p class="text-muted" v-text="$t('other.input_required')">* 為必填項目</p>


                        <b-row>
                            <b-col md="3">
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="fa fa-diamond"></i>ID *</b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="number" step="1" min="1" max="9999" class="form-control"
                                                    v-model.number="device.deviceid"
                                                    :disabled="true" />
                                </b-input-group>
                            </b-col>
                            <b-col md="4">
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="fa fa-diamond"></i>Hash ID *</b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" class="form-control" v-model.trim="device.hashid"
                                                    :maxlength="$tools.input.getInputMaxLength('device','hashid')"
                                                    :disabled="true" />
                                </b-input-group>
                            </b-col>
                            <b-col md="3" v-if="is_create">
                                <SelectorHashid class="block-area" :deviceType="'accesspoint'" @result-value="setHashID($event)" :existDevices="admin_List"></SelectorHashid>
                            </b-col>

                        </b-row>



                        <b-row>

                            <!-- Nickname -->
                            <b-col lg="8">
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="icon-pencil"></i>{{ $t('menu.name') }}</b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" class="form-control" v-model.trim="device.nickname"
                                                :maxlength="$tools.input.getInputMaxLength('device','nickname')" />
                                </b-input-group>
                            </b-col>

                            <!-- Status -->
                            <b-col md="12">
                                <div class="area-overflow-x grab-bing scroll-style block-area" v-dragscroll>
                                    <div class="block-sm">{{ $t('n.device') }} {{ $t('menu.status') }}</div>
                                    <div class="block-sm">
                                        <b-form-radio-group v-model="device.status" :plain="true" buttons>
                                            <b-form-radio v-for="(status, idx_status) in admin_Status_List" :key="idx_status"
                                                        :value="status.value"
                                                        :disabled="status.disabled"
                                                        :button-variant="( device.status == status.value ? status.buttonVariant.replace('outline-','') : status.buttonVariant )" >
                                                {{ $t('status.device.' + status.value) }}
                                            </b-form-radio>
                                        </b-form-radio-group>
                                    </div>
                                </div>
                            </b-col>

                            <!-- Nickname -->
                            <b-col lg="8">
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="fa fa-rss"></i>ICCID</b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" class="form-control" v-model.trim="device.iccid"
                                                :maxlength="$tools.input.getInputMaxLength('device','tv_name')" />
                                </b-input-group>
                            </b-col>

                        </b-row>

                        <br>

                        <b-row>
                            <b-col md="8">

                                <b-input-group class="mb-3">

                                    <!-- 緯度 -->
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.latitude') }}</b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" class="form-control" v-model="device.latitude" :state="checkLatitude"></b-form-input>

                                    <!-- 經度 -->
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.longitude') }}</b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="text" class="form-control" v-model="device.longitude" :state="checkLongtitude"></b-form-input>

                                </b-input-group>

                            </b-col>
                            <b-col md="8">

                                <!-- 製造時間 -->
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="fa fa-calendar"></i>{{ $t('menu.manufacture_date') }}
                                            ( {{ timezone }} )
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="date" class="form-control input-date" v-model.trim="device.manufacture_date" required />
                                    <b-form-input type="time" class="form-control input-date" v-model.trim="device.manufacture_time" required />
                                    <!-- {{ device.manufacture_time }} -->
                                </b-input-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="8">

                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text><i class="icon-menu"></i>{{ $t('menu.admin_note') }}</b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-textarea type="text" v-model="device.note" :rows="1" :max-rows="6"></b-form-textarea>
                                </b-input-group>

                            </b-col>
                            <b-col md="4" align-self="end">

                                <div class="text-right">
                                    <b-button variant="dark" class="px-4 btn-upload"
                                              v-if="is_create == false"
                                              @click="remove_confirm(device)" :disabled="uploading" >
                                        <i class="fa fa-minus"></i>棄置 {{ $t('n.device') }}
                                    </b-button>

                                    <b-button v-if="is_create" variant="success" class="px-4 btn-upload" @click="create_deviceInfo(device)" :disabled="uploading || checkDisabled" >
                                        {{ $t('menu.upload') }}
                                    </b-button>
                                    <template v-else>
                                        <b-button variant="success" class="px-4 btn-upload" @click="upload_deviceInfo(device)" :disabled="uploading || checkDisabled" >
                                            {{ $t('menu.save_changes') }}
                                        </b-button>

                                        <b-button variant="danger" class="px-4 btn-upload btn-red"
                                            @click="clone_device"
                                            :disabled="uploading">
                                            <i class="fa fa-plus"></i>{{ $t('menu.clone') }}
                                        </b-button>
                                    </template>

                                </div>

                            </b-col>
                        </b-row>


                    </div>
                </b-col>
            </b-row><!-- end b-row -->


            <!-- Modal: confirm delete -->
            <b-modal v-model="confirm_show_delete" :title="$t('other.confirm_delete')" header-bg-variant="dark" hide-header-close hide-footer>

                <h4>{{ $t('other.enter_confirmation_code') }}：{{ confirm_text }}</h4>
                <b-form-input type="text" :placeholder="$t('other.enter_confirmation_code')" v-model="confirm_answer"></b-form-input>
                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-upload" @click.prevent="confirm_show_delete = false" :disabled="uploading">
                        <i class="fa fa-close"></i> {{ $t('menu.cancel') }}
                    </button>

                    <b-button variant="success" class="px-4 btn-upload"
                            @click="delete_device(confirm_device)"
                            :disabled="confirm_text != confirm_answer">{{ $t('menu.delete') }}</b-button>
                </div>
            </b-modal>


        </div>
        <div v-else>
            <h4>無此裝置，請確認是否為正確的 Hash ID：{{ $route.params.deviceID }}</h4>
        </div>


    </div>

</template>

<script>
    import { mapState } from 'vuex'
    import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域
    import AgriLoading  from '@/views/components/AgriLoading'
    import SelectorHashid  from '@/views/admin/device/Selector_Hashid'

    export default {
        directives: {
            'dragscroll': dragscroll,
        },
        components: {
            AgriLoading,
            SelectorHashid,
        },
        data() {
            return {
                loading: false,
                uploading: false,
                device: undefined,
                is_create: false,
                timezone: 'Asia/Taipei',

                // confirm
                confirm_show_delete: false,
                confirm_text: '',
                confirm_answer: '',
                confirm_device: undefined,
            }
        },
        computed: {
            ...mapState({
                'admin_List': state => state.accesspoint.accesspoints,
                'admin_Status_List': state => state.accesspoint.list_status,
            }),

            checkLongtitude ()
            {
                return this.$tools.input.checkFloat( this.device.longitude );
            },

            checkLatitude ()
            {
                return this.$tools.input.checkFloat( this.device.latitude );
            },

            checkDisabled ()
            {
                if ( this.device.manufacture_date == '' ) return true
                if ( this.device.manufacture_time == '' ) return true

                if ( this.device.deviceid == undefined ) return true
                if ( this.device.hashid   == undefined ) return true

                if ( this.checkLongtitude == false ) return true
                if ( this.checkLatitude == false )   return true
                return false
            },

        },
        watch:
        {
        },
        mounted ()
        {
            let _deviceID = this.$route.params.deviceID;
            this.timezone = this.$tools.date.getTimezoneNow();

            if (this.$route.name == 'New AccessPoint')
            {
                this.init_create();
            }
            else if (_deviceID)
            {
                this.getDevice_byID(_deviceID);
            }
        },
        methods:
        {
            init_create ( deviceInfo = {} )
            {
                this.is_create = true;

                this.device = {
                    deviceid:          undefined,
                    hashid:             undefined,
                    nickname:           undefined,
                    iccid:              undefined,
                    latitude:           undefined,
                    longitude:         undefined,
                    manufacture:        this.$tools.date.getDateNow( this.timezone, 'YYYY-MM-DD HH:mm' ),
                    manufacture_date:   this.$tools.date.getDateNow( this.timezone, 'YYYY-MM-DD' ),
                    manufacture_time:   this.$tools.date.getDateNow( this.timezone, 'HH:mm' ),
                    status:             this.admin_Status_List[1].value,
                    note:               undefined,
                }

                if (deviceInfo.nickname)       this.device.nickname = deviceInfo.nickname
                if (deviceInfo.status)         this.device.status = deviceInfo.status
            },

            clone_device ()
            {
                this.$router.push({ name: 'New AccessPoint' })
                this.init_create( this.device )
            },

            setHashID (result)
            {
                this.device.deviceid  = result.id
                this.device.hashid     = result.hashid
                this.device.type       = result.type
            },

            cloneParameters ()
            {
                this.device.visualization = this.device.sensor_params.slice();
            },

            modal_init (device)
            {
                this.confirm_show_delete = false;
                this.confirm_text = this.$tools.input.randomCode();
                this.confirm_answer = '';
                this.confirm_device = device;
            },
            remove_confirm (device)
            {
                this.modal_init(device);
                this.confirm_show_delete = true;
            },
            // 刪除移除裝置
            delete_device (device)
            {
                this.confirm_show_delete = false;
                this.uploading = true;

                const options = {
                    method:'DELETE',
                    url: this.$config.getAPI_URL('Admin_AccessPoint', { deviceID: device.hashid }),
                }
                this.$http(options)
                .then( res => {
                    this.uploading = false;
                    this.$toastr.s( this.$t('other.update_succeeded'), this.$t('menu.delete') + ' ' + this.$t('n.device') + ': ' + device.hashid );

                    this.$router.push( this.$config.getPagesURL('list_accesspoints') );
                })
                .catch( err => {
                    this.uploading = false;
                    this.$toastr.e( this.$t('other.update_failed') + '<br>' + err, this.$t('menu.delete') + ' ' + this.$t('n.device') + ': ' + device.hashid );
                })
            },

            getDevice_byID ( deviceID )
            {
                this.loading = true
                const settings = {
                    deviceID: deviceID,
                    timezone: this.timezone,
                }
                this.$store.dispatch('accesspoint/get_Detail', settings)
                    .then( res => {

                        if ( res.accesspoint )
                        {
                            res.accesspoint.status = ( res.accesspoint.status ? res.accesspoint.status : this.admin_Status_List[0].value )

                            this.device = res.accesspoint
                        }

                        this.loading = false
                    })
                    .catch( err => {
                        this.loading = false
                    })
            },

            // 上傳並更新專案基礎資訊
            upload_deviceInfo (device)
            {
                this.uploading = true;

                let _data = {
                    nickname:       device.nickname,
                    note:           device.note,
                    iccid:          device.iccid,
                    status:         device.status,
                };

                // nullable
                if ( device.latitude )  { _data.latitude = device.latitude; }
                if ( device.longitude ){ _data.longitude = device.longitude; }

                if ( device.manufacture )
                {
                    let _timezoneDate = device.manufacture_date + ' ' + device.manufacture_time
                    _data.manufacture = this.$tools.date.dataTimeZone_to_UTC( _timezoneDate , this.timezone, 'YYYY-MM-DD HH:mm' ) // 轉成 UTC time
                }

                const options = {
                    method:'PUT',
                    url: this.$config.getAPI_URL('Admin_AccessPoint', { deviceID: device.hashid }),
                    data: _data
                }
                this.$http(options)
                .then( res => {

                    this.uploading = false;
                    this.getDevice_byID( device.hashid );
                    this.$toastr.s( this.$t('other.update_succeeded'), this.$t('menu.device_information') + ': ' + device.nickname );
                })
                .catch( err => {

                    this.uploading = false;
                    this.$toastr.e( this.$t('other.update_failed'), this.$t('menu.device_information') + ': ' + device.nickname );
                })

            },

            // 建立新的 Device
            create_deviceInfo (device)
            {
                this.uploading = true;

                let _data = {
                    device_hash_id: device.hashid,
                    device_id:      device.deviceid,
                    nickname:       device.nickname,
                    note:           device.note,
                    iccid:          device.iccid,
                    status:         device.status,
                };

                // nullable
                if ( device.latitude )  { _data.latitude = device.latitude; }
                if ( device.longitude ){ _data.longitude = device.longitude; }

                // required
                let _timezoneDate = device.manufacture_date + ' ' + device.manufacture_time
                _data.manufacture = this.$tools.date.dataTimeZone_to_UTC( _timezoneDate , this.timezone, 'YYYY-MM-DD HH:mm' ) // 轉成 UTC time

                const options = {
                    method:'POST',
                    url: this.$config.getAPI_URL('AccessPoints'),
                    data: _data
                }
                this.$http(options)
                .then( res => {

                    this.uploading = false;
                    this.$toastr.s( this.$t('other.update_succeeded'), this.$t('menu.device_information') + ': ' + device.hashid );
                    this.$router.push( this.$config.getPagesURL('list_accesspoints') );
                })
                .catch( err => {

                    this.uploading = false;
                    this.$toastr.e( this.$t('other.update_failed'), this.$t('menu.device_information') + ': ' + device.hashid );
                })

            },


        }
    }

</script>

<style lang="scss" scoped>

.input-checkbox
{
    color: #1d9bda;
    border-color: #79e6d2;
    background-color: white;
}

.list-sensor-area
{
    padding: 5px;
    margin-bottom: 10px;
    font-size: 0.92rem;
    color: #7a8787;
}
.list-sensor-item
{
    display: inline-block;
    min-width: 220px;
}

</style>
